<template>
    <div class="slider">
        <k-slide 
            :pos="'left'" 
            @clicked="previousSlide"
            :title="slides[slideBefore].title" 
            :source="slides[slideBefore].source"
            ref="left">
        </k-slide>
        <router-link :to="{name: 'project', params: {'title': slides[currentSlide].title.toLowerCase()}}">
            <k-slide 
                :pos="'center'" 
                :title="slides[currentSlide].title" 
                :source="slides[currentSlide].source"
                ref="center">
            </k-slide>
        </router-link>
        <k-slide 
            :pos="'right'" 
            @clicked="nextSlide"
            :title="slides[slideAfter].title" 
            :source="slides[slideAfter].source"
            ref="right">
        </k-slide>
    </div>
</template>

<script>
import Slide from './Slide';
import { TimelineMax, Expo } from 'gsap';
import DB from '../database/Base';
import store from '../store/Store';

export default {
    components: {
        'k-slide': Slide
    },
    data() {
        return {
            currentSlide: 0,
            slides: DB,
            state: store.state
        }
    },
    computed: {
        slideBefore() {
            return this.currentSlide === 0 ? this.slides.length-1 : this.currentSlide-1;
        },
        slideAfter() {
            return this.currentSlide === this.slides.length-1 ? 0 : this.currentSlide+1;
        }
    },
    mounted() {
        this.state.freeze = false;
        this.animateMount();
    },
    methods: {
        previousSlide() {
            if (this.currentSlide > 0) {
                this.currentSlide--;
            } else {
                this.currentSlide = this.slides.length-1;
            }
            this.animatePrevious();
        },
        nextSlide() {
            if (this.currentSlide < this.slides.length-1) {
                this.currentSlide++;
            } else {
                this.currentSlide = 0;
            }
            this.animateNext();
        },
        animateMount() {
            const {left, center, right} = this.$refs;

            let tl = new TimelineMax();
            tl
            .fromTo(center.$refs.slide, 1, {left: '60%', opacity: 0, scale: 1.1}, {left: '50%', opacity: 1, scale: 1, ease: Expo.easeOut})
            .fromTo(center.$refs.title, 1, {x: '-50px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(left.$refs.slide, 1, {x: '-45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(right.$refs.slide, 1, {x: '45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1');
        },
        animateUnmount() {
            const {left, center, right} = this.$refs;

            let tl = new TimelineMax();
            tl
            .to(center.$refs.title, 1, {letterSpacing: '1.3rem', ease: Expo.easeOut})
            .to(center.$refs.slide, 1, {scale: 1.1, ease: Expo.easeOut}, '-=1')
            .to(left.$refs.slide, 1, {x: '-80px', opacity: 0, ease: Expo.easeOut}, '-=1')
            .to(right.$refs.slide, 1, {x: '80px', opacity: 0, ease: Expo.easeOut}, '-=1');
        },
        animatePrevious() {
            const {left, center, right} = this.$refs;

            let tl = new TimelineMax();
            tl
            .fromTo(center.$refs.slide, 1, {left: '40%', opacity: 0, scale: 1.1}, {left: '50%', opacity: 1, scale: 1, ease: Expo.easeOut})
            .fromTo(center.$refs.title, 1, {x: '-50px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(left.$refs.slide, 1, {x: '-45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(right.$refs.slide, 1, {x: '45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1');
        },
        animateNext() {
            const {left, center, right} = this.$refs;

            let tl = new TimelineMax();
            tl
            .fromTo(center.$refs.slide, 1, {left: '60%', opacity: 0, scale: 1.1}, {left: '50%', opacity: 1, scale: 1, ease: Expo.easeOut})
            .fromTo(center.$refs.title, 1, {x: '-50px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(left.$refs.slide, 1, {x: '-45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1')
            .fromTo(right.$refs.slide, 1, {x: '45px', opacity: 0}, {x: 0, opacity: 1, ease: Expo.easeOut}, '-=1');
        }
    }
}
</script>


// WEBPACK FOOTER //
// src/components/Slider.vue